module.exports = __webpack_public_path__ + "static/media/exibart.2bc447b1.png";